import React, { FC } from 'react';
import { ISuggestion } from '../model/Suggestion';
import { IAutocompleteSuggestions } from '../model/AutocompleteSuggestions';
import { SuggestionsList } from 'features/pi/view/uiManager/suggestions-list/suggestions-list';

export interface SuggestionsProps {
    suggestions?: IAutocompleteSuggestions;
    onSelect: (suggestion: ISuggestion) => void;
}

export const Suggestions: FC<SuggestionsProps> = (props) => {
    const { suggestions, onSelect } = props;

    const suggestionItems = suggestions?.items.getOrderedItems() || [];
    const suggestionsTexts = suggestionItems.map((suggestion) => suggestion.query.get());

    if (suggestionsTexts.length === 0) {
        return null;
    }

    return (
        <SuggestionsList
            suggestions={suggestionsTexts}
            input={suggestions?.query.get()}
            onSuggestionClick={(selectedText) => {
                const suggestion = suggestionItems.find(
                    (item) => item.query.get() === selectedText,
                );
                if (suggestion) {
                    onSelect(suggestion);
                }
            }}
        />
    );
};
